"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactPopup = _interopRequireDefault(require("react-popup"));
var _ExperimentFileTypeMultiChoice = _interopRequireDefault(require("./ExperimentFileTypeMultiChoice"));
var _ReactPopupStyle = _interopRequireDefault(require("./ReactPopupStyle"));
var _validateAndDownloadExperimentFiles = _interopRequireDefault(require("./validateAndDownloadExperimentFiles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(host, fileTypes, target) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _validateAndDownloadExperimentFiles["default"];
  // Render Popup component with some styling, it won’t be visible just yet
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ReactPopupStyle["default"], null), /*#__PURE__*/_react["default"].createElement(_reactPopup["default"], null)), document.getElementById(target));

  // Register the `prompt` plugin
  _reactPopup["default"].registerPlugin("prompt", function (experimentAccessions) {
    var selectedFileTypeIds = fileTypes.map(function (fileType) {
      return fileType.id;
    });
    var setSelectedFileTypeIds = function setSelectedFileTypeIds(fileTypeIds) {
      return selectedFileTypeIds = fileTypeIds;
    };
    _reactPopup["default"].create({
      title: null,
      content: /*#__PURE__*/_react["default"].createElement(_ExperimentFileTypeMultiChoice["default"], {
        fileTypes: fileTypes,
        onChange: setSelectedFileTypeIds
      }),
      buttons: {
        left: [{
          text: "Cancel",
          key: "esc",
          action: function action() {
            _reactPopup["default"].close();
          }
        }],
        right: [{
          text: "Download",
          className: "success",
          key: "enter",
          action: function action() {
            if (selectedFileTypeIds.length) {
              callback(host, experimentAccessions, selectedFileTypeIds);
              _reactPopup["default"].close();
            }
          }
        }]
      }
    });
  });

  // Return a function that makes the pop-up visible
  return function (checkedRows) {
    return _reactPopup["default"].plugins().prompt(checkedRows);
  };
};